import { render, staticRenderFns } from "./FormDiagramRVS.vue?vue&type=template&id=c9e94c20&scoped=true"
import script from "./FormDiagramRVS.vue?vue&type=script&lang=ts"
export * from "./FormDiagramRVS.vue?vue&type=script&lang=ts"
import style0 from "./FormDiagramRVS.vue?vue&type=style&index=0&id=c9e94c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e94c20",
  null
  
)

export default component.exports